import { GameLoop } from './GameLoop';
import { competitorSystemUpdate } from '../systems/CompetitorSystem';
import { contractSystemUpdate } from '../systems/ContractSystem';
import { productionSystemUpdate } from '../systems/ProductionSystem';
import { trainingSystemUpdate } from '../systems/TrainingSystem';
import { levelingSystemUpdate } from '../systems/LevelingSystem';
import { moraleSystemUpdate } from '../systems/MoraleSystem';
import { marketSystemUpdate } from '../systems/MarketSystem';
import { financeSystemUpdate } from '../systems/FinanceSystem';
import { eventSystemUpdate } from '../systems/EventSystem';
import { unlockSystemUpdate } from '../systems/UnlockSystem';
import { hiringSystemUpdate } from '../systems/HiringSystem';
import { prestigeSystemUpdate } from '../systems/PrestigeSystem';
import { achievementSystemUpdate } from '../systems/AchievementSystem';

/**
 * Creates a GameLoop with all simulation systems registered in the correct order.
 * This is the single source of truth for system registration.
 */
export function createGameLoop(): GameLoop {
  const loop = new GameLoop();

  // Order matters — systems see mutations from earlier systems in the same tick
  loop.registerSystem('competitor', competitorSystemUpdate);
  loop.registerSystem('contract', contractSystemUpdate);
  loop.registerSystem('production', productionSystemUpdate);
  loop.registerSystem('training', trainingSystemUpdate);
  loop.registerSystem('leveling', levelingSystemUpdate);
  loop.registerSystem('morale', moraleSystemUpdate);
  loop.registerSystem('market', marketSystemUpdate);
  loop.registerSystem('finance', financeSystemUpdate);
  loop.registerSystem('event', eventSystemUpdate);
  loop.registerSystem('unlock', unlockSystemUpdate);
  loop.registerSystem('hiring', hiringSystemUpdate);
  loop.registerSystem('prestige', prestigeSystemUpdate);
  loop.registerSystem('achievement', achievementSystemUpdate);

  return loop;
}
